module.exports = __webpack_public_path__ + "img/img34.fcfb902f.png";